const path = '$bigfile'

export const FILE_LIST = `${path}/list`
export const FILE_DELETE = `${path}/delete`
export const FILE_SELECT = `${path}/select`
export const FILE_SELECT_ALL_TOGGLE = `${path}/select/all/toggle`
